import { getCookie } from './cookies';

const DISABLE_REFRESH_COOKIE_NAME = 'disableHPRefresh';
export const isRefreshHPDisabled = () => getCookie(DISABLE_REFRESH_COOKIE_NAME) === 'true';
